// Studio team Inc 3 — the off-air team backchannel panel (col 3 of Host Controls).
// Silent, ephemeral, publisher-to-publisher. Only ever mounts inside the
// host/cohost wrapper in HostControls, so being on screen already means publisher
// — no role branching here. Self-sources the Room via context (mirrors
// SocialChatPanel) and delegates transport/security to useCohostChat.

import { useRoomContext } from '@livekit/components-react';
import { useEffect, useRef, useState } from 'react';

import { useCohostChat } from './useCohostChat';

export function MessagingPanel() {
  const room = useRoomContext();
  const { messages, send } = useCohostChat(room);
  const [body, setBody] = useState('');
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = 0; // newest is at the top
  }, [messages.length]);

  const submit = () => {
    const trimmed = body.trim();
    if (!trimmed) return;
    send(trimmed);
    setBody('');
  };

  return (
    <div className="space-y-3">
      <p className="font-sans text-xs font-medium uppercase tracking-[0.12em] text-video-text-faint">
        Messaging (team only)
      </p>
      <p className="font-sans text-xs text-video-text-faint">
        Visible only to the team on air. Not saved.
      </p>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
        className="flex gap-2"
      >
        <input
          value={body}
          onChange={(e) => setBody(e.target.value)}
          maxLength={500}
          placeholder="Message the team"
          className="min-w-0 flex-1 rounded-md border border-video-line bg-video-inset px-3 py-2 font-sans text-sm text-video-text outline-none focus:border-video-line-strong"
        />
        <button
          type="submit"
          disabled={!body.trim()}
          className="rounded-md bg-video-text px-4 py-2 font-sans text-sm font-medium text-video-bg disabled:opacity-50"
        >
          Send
        </button>
      </form>

      <div
        ref={scrollRef}
        className="h-48 space-y-2 overflow-y-auto rounded-md border border-video-line bg-video-inset p-3"
      >
        {messages.length === 0 ? (
          <p className="font-sans text-xs text-video-text-faint">No messages yet.</p>
        ) : (
          messages
            .slice()
            .reverse()
            .map((m) => (
              <p key={m.id} className="font-sans text-sm leading-snug">
                <span className="font-medium text-video-text">{m.senderName}</span>{' '}
                <span className="text-video-text-muted">{m.body}</span>
              </p>
            ))
        )}
      </div>
    </div>
  );
}
